import { atom } from 'recoil';

import { ACTIVE_TABS } from 'constant';

export const dashboardActiveTab = atom<string>({
	key: 'dashboard-active-tab',
	default: ACTIVE_TABS.KYC,
});
